module.exports = __webpack_public_path__ + "static/media/67-iveco.bec4c806.jpg";